angular.module('component-utils', [])
    .factory('CtUtils', CtUtilsFactory);

CtUtilsFactory.$inject = ['$q', '$timeout'];
function CtUtilsFactory($q, $timeout) {
    return {
        getChar: function (event) {
            if (event.which == null) { // IE
                if (event.keyCode < 32) return null; // special symbol
                return String.fromCharCode(event.keyCode)
            }

            if (event.which != 0 && event.charCode != 0) { // all except IE
                if (event.which < 32) return null; // special symbol
                return String.fromCharCode(event.which); // others
            }

            return null; // special symbol
        },
        request: function request(r) {
            var defer = $q.defer();

            repeat(r);

            return defer.promise;

            function repeat(r) {
                r().then(function success(response) {
                    var headers = response.headers,
                        delay = headers('Retry-After');

                    if (delay) {
                        delay *= 1000;
                    } else {
                        delay = 1000;
                    }

                    if (response.status == 202) {
                        return $timeout(function () {
                            repeat(r);
                        }, delay);
                    }

                    defer.resolve(response)
                }, function error(response) {
                    defer.reject(response)
                })
            }
        }
    }
}


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/ct-payments/component-utils/src/component-utils.js
 ** module id = 83
 ** module chunks = 1
 **/